var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.contenidos),function(contenido,index){return _c('p',{key:index,staticClass:"page-text",class:_vm.columnasContenido(contenido.TamanoDeLaColumna)},[_vm._v(_vm._s(contenido.TextoDelContenido)+" ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7cafd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Micrositios/Formatos/Texto.vue
// module id = null
// module chunks = 